import { useHistory } from 'react-router-dom'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'

import styles from '../Dialog.module.sass'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useRecoilState } from 'recoil'
import { currentTaskFormState } from 'store/atoms'

const submitMessageButton = (submissionType, submitting, i18n) => {
	switch (submissionType) {
		case 'resolve':
			return submitting ? i18n`Resolving` : i18n`Resolve`
		case 'approve':
			return submitting ? i18n`Approving` : i18n`Approve`
		case 'submit':
			return submitting ? i18n`Submitting` : i18n`Submit`
		case 'nullify':
			return submitting ? i18n`Nullifying` : i18n`Nullify`
		default:
			break
	}
}

const TaskMenuController = (props) => {
	const { i18n } = useGlobal()
	const history = useHistory()
	const [, setCurrentTaskFormState] = useRecoilState(currentTaskFormState)

	const { data } = props
	const {
		formId,
		submitting,
		options,
		setSubmissionType = () => {},
		getValues = () => {},
		submissionType,
		requestApprovalTask,
		requestManagerApprovalTask,
		addAssociatedTicket,
		contactInjuredAction,
		hideSubmit,
		appointments,
		appointmentId,
		disableResolver,
	} = data

	const formValues = getValues()

	const buttonOptions = {
		postpone: {
			value: 'postpone',
			text: i18n`Postpone`,
			action: () => {
				setCurrentTaskFormState(
					formValues ? JSON.stringify(formValues) : ''
				)
				history.push('/postpone')
			},
		},
		forward: {
			value: 'forward',
			text: i18n`Forward`,
			action: () => {
				history.push('/forward')
			},
		},
		refuse: {
			value: 'refuse',
			text: i18n`Refuse`,
			action: () => {
				history.push('/refuse', { appointments, appointmentId })
			},
		},
		refuse_request: {
			value: 'refuse_request',
			text: i18n`Refuse`,
			action: () => {
				history.push('/refuse_request')
			},
		},
	}

	let selectedOptions = options
		.map((option) => buttonOptions[option])
		.filter(Boolean)

	if (requestApprovalTask) {
		selectedOptions = [
			{
				value: 'requestApproval',
				text: i18n`Request Approval`,
				action: () => {
					requestApprovalTask({})
				},
			},
			...selectedOptions,
		]
	}

	if (requestManagerApprovalTask) {
		selectedOptions = [
			{
				value: 'requestManagerApproval',
				text: i18n`Request Manager Approval`,
				action: () => {
					requestManagerApprovalTask({})
				},
			},
			...selectedOptions,
		]
	}

	if (addAssociatedTicket) {
		selectedOptions = [
			{
				value: 'ticket',
				text: i18n`Open associated ticket`,
				action: () => {
					addAssociatedTicket()
				},
			},
			...selectedOptions,
		]
	}

	if (contactInjuredAction) {
		selectedOptions = [
			{
				value: 'contactInjured',
				text: i18n`Contact injured`,
				action: () => {
					contactInjuredAction()
				},
			},
			...selectedOptions,
		]
	}

	return (
		<menu className={styles['menu']}>
			{selectedOptions.length ? (
				<ModalOptions
					title={i18n`Options`}
					options={selectedOptions}
					onSelect={(item, _) => {
						item && item.action && item.action()
					}}
				>
					<button
						data-wt-id='options'
						className={styles['menu-button-secondary']}
					>
						{i18n`Options`}
					</button>
				</ModalOptions>
			) : (
				<div />
			)}
			{!hideSubmit && (
				<ActionButton
					className={styles['menu-button-primary']}
					form={`form_${formId}`}
					primary={true}
					disabled={disableResolver}
					onClick={() => {
						setSubmissionType(submissionType)
					}}
				>
					{submitMessageButton(submissionType, submitting, i18n)}
				</ActionButton>
			)}
		</menu>
	)
}

export default TaskMenuController
